import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UIIconsEnum } from 'src/app/shared/enums/icons.enum'; // adjust path if needed

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss'],
})
export class PasswordFieldComponent {
  /**
   * Label for this password field
   * e.g. "New Password", "Confirm Password", "Current Password"
   */
  @Input() label!: string;

  /**
   * FormControl for this password field
   */
  @Input() control!: FormControl;

  /**
   * Tooltip text (optional)
   */
  @Input() tooltip: string | null = null;

  /**
   * Whether to show the Show/Hide toggle button (defaults to true)
   */
  @Input() showHideButton = true;

  /**
   * A map of custom error messages.
   * The keys should match the possible error names that appear in `control.errors`.
   * Example:
   * {
   *   required: 'Password is required',
   *   minlength: 'Password must be at least 8 characters',
   *   pattern: 'Password must contain uppercase, lowercase, a number, etc.'
   * }
   */
  @Input() errorMessages: { [key: string]: string } = {};

  showPassword: boolean = false;

  constructor() {}

  /**
   * Toggle password visibility
   */
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  /**
   * Returns the correct icon based on `showPassword` state
   */
  get visibilityIcon() {
    // UIIconsEnum.Show or UIIconsEnum.Hide from your existing enum
    return this.showPassword ? UIIconsEnum.Show : UIIconsEnum.Hide;
  }

  /**
   * Helper to check if control has a specific error
   */
  hasError(errorName: string): boolean {
    return !!this.control && this.control.touched && this.control.hasError(errorName);
  }
}
